"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgAmenityTime247 = function SvgAmenityTime247(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M1024 512c0 224-182.4 409.6-406.4 409.6-185.6 0-345.6-128-393.6-300.8l-48 86.4c-6.4 9.6-16 16-25.6 16-3.2 0-9.6 0-12.8-3.2-16-6.4-19.2-25.6-12.8-38.4l86.4-156.8c6.4-16 25.6-19.2 38.4-12.8 3.2 0 6.4 3.2 6.4 3.2l137.6 118.4c12.8 9.6 12.8 25.6 3.2 38.4-6.4 6.4-16 9.6-22.4 9.6-6.4 0-12.8-3.2-19.2-6.4l-73.6-64C323.2 758.4 460.8 864 617.6 864c195.2 0 352-156.8 352-352s-156.8-352-352-352v-57.6c224 0 406.4 185.6 406.4 409.6zM124.8 374.4H48v-3.2l22.4-22.4c16-12.8 25.6-25.6 32-32 6.4-6.4 9.6-12.8 12.8-22.4 3.2-6.4 3.2-12.8 3.2-22.4 0-9.6 0-16-6.4-25.6-3.2-6.4-9.6-12.8-19.2-16-6.4-3.2-19.2-6.4-28.8-6.4-9.6 0-16 3.2-22.4 3.2-6.4 0-12.8 3.2-19.2 6.4-6.4 3.2-12.8 9.6-22.4 16l19.2 25.6c9.6-6.4 16-9.6 22.4-16C48 256 54.4 256 60.8 256c6.4 0 12.8 3.2 16 6.4 3.2 3.2 6.4 9.6 6.4 16 0 3.2-3.2 9.6-3.2 12.8-3.2 6.4-6.4 12.8-9.6 16-3.2 3.2-12.8 12.8-25.6 28.8L0 380.8v25.6h124.8v-32zm86.4-6.4h-73.6v-25.6l76.8-115.2h35.2v112H272V368h-22.4v35.2h-38.4V368zm0-28.8v-28.8V288v-16c0 6.4-6.4 12.8-9.6 19.2l-32 48h41.6zm179.2-112h-32l-67.2 176h32l67.2-176zM432 406.4h41.6l67.2-153.6v-22.4h-128v32h86.4l-67.2 144zm262.4 214.4c6.4 0 12.8-3.2 19.2-9.6 9.6-9.6 6.4-22.4-3.2-28.8l-89.6-67.2V336c0-12.8-9.6-22.4-22.4-22.4S576 323.2 576 336v201.6l105.6 80c3.2 3.2 9.6 3.2 12.8 3.2z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgAmenityTime247, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;